import styled from '@emotion/styled';
import type { FC } from 'react';
import { useHighlightedTrackers } from '../../../lib/customHooks';
import { useStore } from '../../../store/reducers';

export const AddHighlightedTrackersToSelectionButton: FC = () => {
  const highlightedTrackers = useHighlightedTrackers();
  const { replaceSample } = useStore((s) => s.trackers.actions);

  const handleClick = () => {
    replaceSample(highlightedTrackers.map((tracker) => tracker.id));
  };

  return <Container onClick={handleClick}>Create Selection</Container>;
};

const Container = styled.div`
  display: flex;
  align-items: center;
`;
